export default "__VITE_ASSET__DHTOQoil__"